import { StyleSheet } from 'aphrodite';
// import typography from 'defaults/typography';
import { hexToRgbA } from 'util/styleUtil';

const getSkin = (theme) => {
	const skin = theme.globalProfiles.palette;
	// const myTypography = typography(theme);

	return StyleSheet.create({
		separationLine: {
			backgroundColor: '#989898'
		},
	});
}

export default getSkin;